import { useSelector } from "react-redux";
import { useRef, useState, useEffect } from "react";
import IphoneAndIpadMockupImage from "../../../assets/smarthome/app_ipad_and_iphone.png";
import hardware from "../../../assets/smartbuilding/hardware.png";
import dashboard from "../../../assets/smartbuilding/screensSection/imacEnergyDashboard.png";
import MockupIphone from "../../../assets/smartbuilding/Mockup_iphone.png";

export default function BusinessModel(props) {
  const { textContent, language } = { ...props };

  const screenWidth = useSelector((state) => state.screen.screenWidth);
  const isMobile = useSelector((state) => state.screen.isMobile);

  return (
    <section className="container-small">
      <div className={`title ${isMobile ? "mobile" : ""}`}>
        <h1 className="title-gradient">
          {textContent.businessModek.title[language]}
        </h1>
      </div>
      <div className="container-empty-small" />
      {!isMobile ? (
        <div className="business-model-container">
          <div className="business-model-item">
            <div className="business-model-image1">
              <img src={hardware} alt="" />
            </div>
            <div className="business-model-text1">
              <h2
                className="business-model-text"
                dangerouslySetInnerHTML={{
                  __html:
                    textContent.businessModek.description.description2[
                      language
                    ],
                }}
              />
            </div>
          </div>
          <div className="container-empty-extra-small" />
          <div className="business-model-item">
            <div className="business-model-text2">
              <h2
                className="business-model-text"
                dangerouslySetInnerHTML={{
                  __html:
                    textContent.businessModek.description.description1[
                      language
                    ],
                }}
              />
            </div>
            <div className="business-model-image">
              <img src={IphoneAndIpadMockupImage} alt="" />
            </div>
          </div>
          <div className="container-empty-extra-small" />
          <div className="business-model-item">
            <div className="business-model-image">
              <img src={dashboard} alt="" />
            </div>
            <div className="business-model-text1">
              <h2
                className="business-model-text"
                dangerouslySetInnerHTML={{
                  __html:
                    textContent.businessModek.description.description3[
                      language
                    ],
                }}
              />
            </div>
          </div>
        </div>
      ) : (
        <div
          className={`business-model-container  ${isMobile ? "mobile" : ""}`}
        >
          <h2
            className="business-model-text-mobile"
            dangerouslySetInnerHTML={{
              __html:
                textContent.businessModek.description.description2[language],
            }}
          />
          <div className="business-model-image-mobile">
            <img src={hardware} alt="" />
          </div>
          <div className="container-empty-extra-small" />
          <h2
            className="business-model-text-mobile"
            dangerouslySetInnerHTML={{
              __html:
                textContent.businessModek.description.description1[language],
            }}
          />
          <div className="business-model-image-mobile">
            <img src={IphoneAndIpadMockupImage} alt="" />
          </div>
          <div className="container-empty-extra-small" />
          <h2
            className="business-model-text-mobile"
            dangerouslySetInnerHTML={{
              __html:
                textContent.businessModek.description.description3[language],
            }}
          />

          <div className="business-model-image-mobile">
            <img src={dashboard} alt="" />
          </div>
        </div>
      )}
    </section>
  );
}
